// Brand marks for the channels: telegram comes from the logos set, vk and max
// live in the project's own icon collection
export const CHANNEL_ICONS = {
  telegram: 'i-logos-telegram',
  vk: 'i-mk-channel-vk',
  max: 'i-mk-channel-max',
}

// Questosha, the company character, stands for the website widget
export const CHANNEL_IMAGES = {
  web_widget: '/questosha.png',
}

export const channelIcon = slug => CHANNEL_ICONS[slug] || 'i-lucide-inbox'

export const channelImage = slug => CHANNEL_IMAGES[slug] || null
